// extracted by mini-css-extract-plugin
export default {"input":"Giftcards_input__zr7O8","isCompany":"Giftcards_isCompany__U0I1c","isCompanyCheck":"Giftcards_isCompanyCheck__dRe8c"};